import {
  Fade,
  Paper, Stack,
} from '@mui/material';

import Layout from 'components/Layout';
import { HEADER_HEIGHT } from 'constants';
import React, { useState } from 'react';
import { Box } from '@mui/system';
import Filters from './Filters';
import MapView from './MapView';
import MerchantCard from './MerchantCard';

function MerchantsMapDesktop({
  merchants, filters, setFilters, center,
  selectedMerchant, setSelectedMerchant,
  loading,
}) {
  const [selectingLocation, setSelectingLocation] = useState(false);

  return (
    <Layout
      header={(
        <Layout.Header
          visibleElements={[
            Layout.Header.Elements.LOGO,
          ]}
        />
      )}
      sidebar={(
        <Box p={3} height="100vh">
          <MapView
            merchants={merchants}
            center={center}
            selectedMerchant={selectedMerchant}
            setSelectedMerchant={setSelectedMerchant}
            height="100%"
          />
        </Box>

      )}
      sidebarWidth="calc(100vw - 420px)"
    >
      <Stack
        component={Paper}
        elevation={0}
        sx={{ height: `calc(100vh - (${HEADER_HEIGHT}px + var(--gap-top)))` }}
      >
        <Filters
          value={filters}
          onChange={setFilters}
          onSelectingLocation={setSelectingLocation}
          mt={3}
        />
        <Fade in={!selectingLocation}>
          <Stack
            sx={{
              width: 400,
              pl: 2,
              pt: 1,
              maxHeight: '100%',
              overflowY: 'auto',
            }}
            gap={2}
          >
            {
              loading ? (
                <>
                  <MerchantCard loading />
                  <MerchantCard loading />
                  <MerchantCard loading />
                </>
              ) :
                merchants.map((m) => (
                  <MerchantCard
                    merchant={m}
                    key={m.id}
                    isSelected={m.id === selectedMerchant?.id}
                    onClick={() => {
                      setSelectedMerchant(m);
                    }}
                  />
                ))
            }
          </Stack>
        </Fade>
      </Stack>
    </Layout>

  );
}

export default MerchantsMapDesktop;
